import * as React from 'react';
import { useClickOutside } from '../../../../hooks/useClickOutside';
import { useEscapeKey } from '../../../../hooks/useEscapeKey';

/**
 * Hook that handles click-outside-to-close and escape-key-to-close
 * for date picker components.
 *
 * @param containerRef - Ref to the picker container element
 * @param isOpen - Whether the picker dropdown is currently open
 * @param setIsOpen - Setter to close the picker
 * @param onEscapeFocus - Optional callback to restore focus after Escape press
 */
export function usePickerDismiss(
  containerRef: React.RefObject<Element | null>,
  isOpen: boolean,
  setIsOpen: (open: boolean) => void,
  onEscapeFocus?: () => void
): void {
  const handleClose = React.useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  const handleEscape = React.useCallback(() => {
    setIsOpen(false);
    onEscapeFocus?.();
  }, [setIsOpen, onEscapeFocus]);

  useClickOutside(containerRef, handleClose, isOpen);
  useEscapeKey(handleEscape, isOpen);
}
